export const CONTRACT_ERROR = {
  INSUFFICIENT_ASSET_ALLOWANCE: 'insufficient asset allowance',
  INSUFFICIENT_ASSET_TOKEN: 'insufficient asset token',
  USER_REJECTED_REQUEST: 'user rejected the request',
  APPLICATION_IS_NOT_ACTIVE: 'application is not active',
};
